"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Widgets = _interopRequireWildcard(require("../../../../swcp-base/js/modules/analytics/Widgets"));
var _DataContainer = _interopRequireDefault(require("../../../../swcp-base/js/modules/analytics/Widgets/DataContainer"));
var _connect = _interopRequireDefault(require("react-redux/es/connect/connect"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapStateToProps = state => {
  return {
    analytics: state.analytics
  };
};
class Dashboard extends _react.default.Component {
  render() {
    const {
      analytics
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "container-fluid justify-content-left mt-5"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-narrow"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex mb-4"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "page-title ml-0"
    }, "Analytics"))));
  }
}
var _default = exports.default = (0, _connect.default)(mapStateToProps, null)(Dashboard);
module.exports = exports.default;